<template>
  <a-modal
    class="template-receive-test-modal"
    :title="$t('TP_Receive_1')"
    :visible="visible"
    :maskClosable="false"
    centered
    @cancel="handleCancel"
  >
    <!-- custom footer -->
    <template v-slot:footer>
      <a-button key="back" @click="handleCancel">{{$t("Common_Cancel")}}</a-button>
      <a-button
        key="submit"
        type="primary"
        :loading="loading"
        @click="handleOk"
      >
        {{$t("TP_Receive_3")}}
      </a-button>
    </template>

    <!-- contents -->
    <div class="content-text">
      <div>{{$t("TP_Receive_4")}}</div>
      <div>{{$t("TP_Receive_5")}}</div>
      <div>({{$t("TP_Receive_6")}})</div>
    </div>
    <div class="content-group">
      <InputComponent
        customClass="template-input"
        type="text"
        :title="$t('TP_Receive_7')"
        moduleName="template"
        name="senderEmail"
        :value="senderEmail"
        :validation="['required', 'email']"
      />
    </div>
  </a-modal>
</template>

<script>
import { computed, reactive, toRefs, onMounted, onUnmounted } from "vue";
import { useStore } from "vuex";
import axios from "axios";
import { apiUrl, timeFormatFromUTCEpoch } from "@/utils/common";
import InputComponent from "@/components/commonComponents/InputComponent";

export default {
  name: "TemplateReceiveTestModal",
  props: {
    mode: String,
    visible: Boolean,
    userInfo: Object,
    toggleModal: Function,
  },
  components: {
    InputComponent,
  },
  setup(props) {
    const store = useStore();
    const templateState = computed(() => store.getters["template/STATE"]);
    const inputValues = computed(
      () => store.getters["template/GET_INPUT_VALUES"]
    );

    const state = reactive({
      loading: false,
      enable: true,
    });

    const formState = reactive({
      senderEmail: "",
    });

    onMounted(() => {
      store.dispatch("template/SET_INPUT_VALUE", {
        senderEmail: "",
      });
    });

    onUnmounted(() => {
      // 입력 값 초기화
      store.dispatch("template/INIT_INPUT_VALUE");
    });
    // 필수 항목 입력 여부 체크
    const checkValid = (compareArray) => {
      let enableArray = [];
      compareArray.map((key) => {
        const value = inputValues.value[key];
        if (!!value || value === 0) {
          enableArray.push(key);
        }
      });

      state["enable"] = enableArray.length === compareArray.length;
    };

    // 취소 버튼 이벤트
    const handleCancel = () => {
      props.toggleModal();
    };

    // 실행 버튼 이벤트
    const handleOk = async () => {
      state.loading = true;

      checkValid(Object.keys(formState));

      if (state["enable"]) {
        try {
          const params = {
            senderEmail: inputValues.value["senderEmail"],
            templateNoArray: templateState.value.selectedNoArray,
          };
          const response = await axios.post(
            apiUrl + "Template/ReceiveTest",
            params
          );
          if (response && !response.data.error) {
            store.dispatch("user/RECEIVE_TEST", response);
          }
        } catch (error) {
          console.log("receive test error", error);
        }
        props.toggleModal();
      }

      state.loading = false;
    };

    return {
      ...toRefs(state),
      ...toRefs(formState),
      handleCancel,
      handleOk,
      timeFormatFromUTCEpoch,
    };
  },
};
</script>